import Vue from 'vue'
import constant from '@/constant'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiGetHouseRateComment,
    apiTenantGetCompanyImages,
} from "@/apis/api.js"; 
// import { 
//     chageNunToChinese
// } from "@/assets/js/global.js"; 


/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_house_detail: 'shareHouse/set_house_detail',
    set_house_rate_comment: 'shareHouse/set_house_rate_comment',
    set_house_company_shot: 'shareHouse/set_house_company_shot',
    set_house_is_publish: 'shareHouse/set_house_is_publish',
    set_house_map_is_loaded: 'shareHouse/set_house_map_is_loaded',
}

// count state 必須是 Object
const state = {
    houseDetail: {},
    houseRateCommentTotal: 0,
    houseRateComment: [],
    houseRateCommentAverageRate: 0,
    isPublish: true,
    isMapLoaded: false,
    companyShot: null
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_SHARE_HOUSE_DETAIL: (state) => {
        return state.houseDetail
    },
    GET_SHARE_HOUSE_STATUS: (state) => {
        return state.houseDetail.houseStatus
    },
    GET_SHARE_HOUSE_NAME: (state) => {
        return state.houseDetail.name
    },
    GET_SHARE_HOUSE_DESCRIPTION: (state) => {
        return state.houseDetail.description
    },
    GET_SHARE_HOUSE_RENT_MONTHLY: (state) => {
        return state.houseDetail.rentMonthly
    },
    GET_SHARE_HOUSE_SIZE: (state) => {
        return state.houseDetail.size
    },
    GET_SHARE_HOUSE_ID: (state) => {
        return state.houseDetail.cid
    },
    GET_SHARE_HOUSE_COVER: (state) => {
        if(state.houseDetail.imageUrl){
            return constant.imageUrl+state.houseDetail.imageUrl[0]
        }else{
            return null
        }
    },
    GET_SHARE_HOUSE_HOUSETYPE: (state) => {
        let houseType = state.houseDetail.houseType

        if( houseType == 1){
            return '整層住家'
        }else if( houseType == 2){
            return '套房'
        }else if( houseType == 3){
            return '雅房'
        }
    },
    GET_SHARE_HOUSE_BUILDINGTYPE: (state) => {
        let buildingType = state.houseDetail.buildingType

        if( buildingType == 1){
            return '公寓'
        }else if( buildingType == 2){
            return '電梯大樓'
        }else if( buildingType == 3){
            return '透天'
        }else if( buildingType == 4){
            return '別墅'
        }
    },
    GET_SHARE_HOUSE_MOVE_IN_DATE: (state) => {
        return state.houseDetail.moveInDate
    },
    GET_SHARE_HOUSE_HAS_ATTORNEY: (state) => {
        return state.houseDetail.hasAttorney
    },
    GET_SHARE_HOUSE_FLOOR: (state) => {
        return state.houseDetail.floor
    },
    GET_SHARE_HOUSE_SHOTEST_PERIOD: (state) => {
        return state.houseDetail.shortestPeriod
    },
    GET_SHARE_HOUSE_PATTERN: (state) => {
        let houseType = state.houseDetail.houseType
        let housePattern = state.houseDetail.housePattern
        let roomPattern = state.houseDetail.roomPattern
        if( houseType == 1){
            if(housePattern != null && housePattern != undefined){
                return ''+Vue.prototype.chageNunToChinese(housePattern.bedroom)+'房'+Vue.prototype.chageNunToChinese(housePattern.sharedRoom)+'廳'+Vue.prototype.chageNunToChinese(housePattern.bathroom)+'衛'+Vue.prototype.chageNunToChinese(housePattern.balcony)+'陽台'   
            }else{
                return '零房零廳零衛零陽台'
            }
        }else{
            if(roomPattern != null && roomPattern != undefined){
                let balcony = roomPattern.hasBalcony?'有':'無'
                let duplex = roomPattern.hasDuplex?'有':'無' 
                return  balcony+'陽台'+duplex+'閣樓'    
            }else{
                return '無陽台無閣樓'
            }
        }
    },
    GET_SHARE_HOUSE_EQUIPMENT: (state) => {
        return state.houseDetail.equipment
    },
    GET_SHARE_HOUSE_RENT_INCLUDE: (state) => {
        return state.houseDetail.rentInclude?state.houseDetail.rentInclude:[]
    },
    GET_SHARE_HOUSE_RULES: (state) => {
        return state.houseDetail.rules?state.houseDetail.rules:[]
    },
    GET_SHARE_HOUSE_ADDRESS: (state) => {
        return state.houseDetail.address
    },
    GET_SHARE_HOUSE_LAT_LNG: (state) => {
        return {lat:state.houseDetail.lat, lng:state.houseDetail.lng}
    },
    GET_SHARE_HOUSE_LANDLORD_INFO: (state) => {
        return state.houseDetail.landlordInfo
    },
    GET_SHARE_HOUSE_TASK_TAKER: (state) => {
        return state.houseDetail.taskTaker
    },
    GET_SHARE_HOUSE_TASK_TAKER_INFO: (state) => {
        return state.houseDetail.taskTakerInfo
    },
    GET_SHARE_HOUSE_ENTERPRISE: (state) => {
        return state.houseDetail.management
    },
    GET_SHARE_HOUSE_ENTERPRISE_NAME: (state) => {
        return state.houseDetail.companyName
    },
    GET_SHARE_HOUSE_ENTERPRISE_AUDITED_TIME: (state) => {
        return state.houseDetail.auditedTime
    },
    GET_SHARE_HOUSE_ENTERPRISE_AUDITED_STATUS: (state) => {
        return state.houseDetail.auditedStatus
    },
    GET_SHARE_HOUSE_ENTERPRISE_INTRO: (state) => {
        return state.houseDetail.introduction
    },
    GET_SHARE_HOUSE_GOOD_HOUSE: (state) => {
        return state.houseDetail.goodHouse
    },
    GET_SHARE_HOUSE_GOOD_LIVE: (state) => {
        return state.houseDetail.goodToLive
    },
    GET_SHARE_HOUSE_FEATURE_LIST: (state) => {
        return state.houseDetail.featureList
    },
    GET_SHARE_HOUSE_HOUSE_GROUP: (state) => {
        return state.houseDetail.houseGroupList?state.houseDetail.houseGroupList[0].houses:[]
    },
    GET_SHARE_NEAR_STATION: (state) => {

        if(state.houseDetail.nearestStation && state.houseDetail.nearestStationDistance){
            return `距離${state.houseDetail.nearestStation+state.houseDetail.nearestStationDistance}M`
        }else{
            return false
        }
    },
    GET_SHARE_HOUSE_ENTERPRISE_SHOT: (state) => {
        return state.companyShot
    },
    GET_SHARE_HOUSE_RATE_COMMENT: (state) => {
        return state.houseDetail.landlordInfo
    },
    GET_SHARE_HOUSE_POLICY: (state) => {
        return state.houseDetail.housePolicy
    },
    GET_SHARE_HOUSE_RATE_COUNT_LIST: (state) => {
        return state.houseDetail.rateCountList
    },
    GET_SHARE_HOUSE_PAY_RENT_DAY: (state) => {
        if(state.houseDetail.payByRentPayDay){
            return '每月'+state.houseDetail.rentPayDay+'號繳交房租'
        }else{
            return '依合約起租日繳交房租'
        }
    },
    GET_SHARE_HOUSE_IS_PUBLISH: (state) => {
        // if(state.houseDetail.publish == undefined){
        //     return true
        // }else{
        //     return state.houseDetail.publish
        // }
        return state.isPublish
    },
    GET_SHARE_HOUSE_IS_DELETE: (state) => {
        if(Object.keys(state.houseDetail).length ==0){
            return true
        }else{
            return false
        }
    },
    GET_SHARE_HOUSE_RATE_AVERAGE: (state) => {
        return state.houseRateCommentAverageRate
    },
    GET_SHARE_HOUSE_RATE_COMMENT: (state) => {
        return state.houseRateComment
    },
    GET_SHARE_HOUSE_RATE_COMMENT_TOTAL: (state) => {
        return state.houseRateCommentTotal
    },
    GET_SHARE_HOUSE_IMAGES: (state) => {
        return state.houseDetail.imageUrl
    },
    GET_SHARE_HOUSE_VIDEO: (state) => {
        return state.houseDetail.filmId
    },
    GET_SHARE_HOUSE_NUM_HIDDEN: (state) => {
        return state.houseDetail.isNumberHidden
    },
    GET_SHARE_HOUSE_MAP_LOADED: (state) => {
        return state.isMapLoaded
    },
    
}

// actions 也是以 Object 形式建構。
const actions = {
    getShareHouseDetail ( {commit, dispatch, state}, cid ) {
        return new Promise((resolve, reject) => {
            const data = {
                houseCid: cid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.houseDetail
                    console.log(value.publish)
                    if(value.publish){
                        commit(types.set_house_is_publish, true);
                    }else if(!value.publish  && value.houseStatus == 2){
                        commit(types.set_house_is_publish, true);
                    }else{
                        commit(types.set_house_is_publish, false);
                    }
                    if(value.management){
                        dispatch('getCompanyShot', cid)
                    }
                    commit(types.set_house_detail, value);
                    resolve()
                }else{
                    commit(types.set_house_is_publish, false);
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getShareHouseRateComment ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            apiGetHouseRateComment(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result

                    if(value.totalPage >= data.page){
                        dispatch('getShareHouseRateComment', {'cid': data.cid, 'page': data.page+1})
                        commit(types.set_house_rate_comment, value);
                    }else{
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setShareHouseMapLoaded ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_house_map_is_loaded, data);
        })
    },
    getCompanyShot ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiTenantGetCompanyImages(data)
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                    let value = URL.createObjectURL(res.data)
                    commit(types.set_house_company_shot, value);

                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_house_detail](state, data){
        console.log(data)
        state.houseDetail = data
    },
    [types.set_house_company_shot](state, data){
        state.companyShot = data
    },
    [types.set_house_rate_comment](state, data){
        state.houseRateCommentTotal = data.totalSize
        state.houseRateCommentAverageRate = data.averageRate
        data.houseRateHistoryVoList.map( item => {
            state.houseRateComment.push(item) 
        })
    },
    [types.set_house_is_publish](state, data){
        state.isPublish = data
    },
    [types.set_house_map_is_loaded](state, data){
        state.isMapLoaded = data
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/shareHouse.js